export default "__VITE_ASSET__Xxazh8kNszwnBNd4Smzisw__"